module.exports = __webpack_public_path__ + "img/logo.c5ade965.png";